import { render, staticRenderFns } from "./GovernmentId.vue?vue&type=template&id=dde55324&scoped=true&"
import script from "./GovernmentId.vue?vue&type=script&lang=js&"
export * from "./GovernmentId.vue?vue&type=script&lang=js&"
import style0 from "./GovernmentId.vue?vue&type=style&index=0&id=dde55324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde55324",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDivider,VIcon})
